import type { NClientsList } from '@app/pages/Clients/ClientsList/ClientsList.types';
import { getFiltersArray } from '@app/pages/Clients/ClientsList/utils/getFiltersArray';

export const handleDateFilters: NClientsList.HandleDateFilters = ({
  startDate,
  endDate,
  targetFiltersAreaId,
  filterGroupIndex,
  filters,
  setFilters,
}) => {
  const filtersPart: NClientsList.FiltersPart =
    getFiltersArray<NClientsList.FiltersPart>({
      ...filters[targetFiltersAreaId],
      [filterGroupIndex]: {
        ...filters[targetFiltersAreaId][filterGroupIndex],
        Values: [
          {
            ...filters?.[targetFiltersAreaId]?.[filterGroupIndex]?.Values?.[0],
            DateStart: startDate || null,
            DateEnd: endDate || null,
          },
        ],
      },
    });

  const result = {
    ...filters,
    [targetFiltersAreaId]: filtersPart,
  };

  setFilters(result);
  return result;
};
